import { objectWithoutProperties as _objectWithoutProperties, toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2, extends as _extends, defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { PaginationModule } from './PaginationModule.js';
import { CardsWrapper } from './components/CardsWrapper.js';
import { CardsLabel } from './components/CardsLabel.js';
import { CardsList } from './components/CardsList.js';
import { NarrowCardPlaceholder } from './components/NarrowCardPlaceholder.js';
import { useContainerProps } from '../../../hooks/useContainerProps.js';
import { ProgressSpinner } from '../../progress-spinner/component.js';
import { PresentationCard } from '../../presentation-card/component.js';
import { formatClassName as _formatClassName } from '../../../utils/formatClassName.js';
var _excluded = ["children"];
/** renders a cards module intended for use inside a section */

var CardsModule = function CardsModule(props) {
  props = useContainerProps(props);
  var _props = props,
      background = _props.background,
      border = _props.border,
      corner = _props.corner,
      shadow = _props.shadow,
      mediaBackground = _props.mediaBackground,
      _props$collection = _props.collection,
      collection = _props$collection === void 0 ? [] : _props$collection,
      _props$keyField = _props.keyField,
      keyField = _props$keyField === void 0 ? 'id' : _props$keyField,
      label = _props.label,
      labelPosition = _props.labelPosition,
      _props$listClasses = _props.listClasses,
      listClasses = _props$listClasses === void 0 ? '' : _props$listClasses,
      type = _props.type,
      isLoadingData = _props.isLoadingData,
      postCards = _props.postCards,
      preCards = _props.preCards,
      _props$wrapCards = _props.wrapCards,
      wrapCards = _props$wrapCards === void 0 ? true : _props$wrapCards,
      _props$wrapperClasses = _props.wrapperClasses,
      wrapperClasses = _props$wrapperClasses === void 0 ? '' : _props$wrapperClasses;
  var styleConfig = {
    background: background,
    corner: corner,
    shadow: shadow,
    border: border,
    mediaBackground: mediaBackground
  };

  var wrapWithCard = function wrapWithCard(member, content) {
    return /*#__PURE__*/React.createElement(PresentationCard, _extends({
      isWrapper: true,
      key: member[keyField]
    }, props, {
      type: type,
      styleConfig: styleConfig
    }), content);
  };

  var renderCards = function renderCards() {
    var cards = [];

    var _props2 = props,
        children = _props2.children,
        clonedProps = _objectWithoutProperties(_props2, _excluded);

    cards.push.apply(cards, _toConsumableArray(renderFixedCards(preCards, '__preCards__')));

    if (typeof children === 'function') {
      cards.push.apply(cards, _toConsumableArray(collection.map(function (member, index) {
        var child = children(member, index);

        if (!wrapCards || child && child.type === PresentationCard) {
          return /*#__PURE__*/React.cloneElement(child, _objectSpread2({
            styleConfig: styleConfig,
            member: member
          }, clonedProps));
        } else {
          return wrapWithCard(member, child);
        }
      })));
    } else {
      cards.push.apply(cards, _toConsumableArray(collection.map(function (member) {
        return React.Children.map(children, function (child) {
          return wrapWithCard(member, /*#__PURE__*/React.cloneElement(child, {
            member: member
          }));
        });
      })));
    }

    cards.push.apply(cards, _toConsumableArray(renderFixedCards(postCards, '__postCards__')));
    return cards;
  };

  var renderFixedCards = function renderFixedCards(elements, keyPrefix) {
    if (!elements) {
      return [];
    }

    if (!Array.isArray(elements)) {
      elements = [elements];
    }

    return elements.map(function (element, index) {
      return wrapWithCard(_defineProperty({}, keyField, "".concat(keyPrefix).concat(index)), element);
    });
  };

  var renderPlaceholders = function renderPlaceholders() {
    if (type !== 'narrow') {
      return null;
    } // render three placeholders to make sure narrow cards stay left aligned


    return [0, 1, 2].map(function (index) {
      return /*#__PURE__*/React.createElement(NarrowCardPlaceholder, {
        key: index
      });
    });
  };

  var cardsListClasses = _formatClassName([listClasses, {
    'is-loading': isLoadingData
  }]);

  return /*#__PURE__*/React.createElement(CardsWrapper, {
    type: type,
    additionalClasses: wrapperClasses
  }, isLoadingData && /*#__PURE__*/React.createElement(ProgressSpinner, {
    containerClassName: "cards-module-loader"
  }), label && /*#__PURE__*/React.createElement(CardsLabel, {
    labelPosition: labelPosition
  }, label), /*#__PURE__*/React.createElement(PaginationModule, props, /*#__PURE__*/React.createElement(CardsList, {
    className: cardsListClasses
  }, renderCards(), renderPlaceholders())));
};

CardsModule.displayName = "CardsModule";
export { CardsModule };